const generegionlist = [
  { species: "AmericanLotus2022", gene_region: "chr1:500000-1500000" },
  { species: "AmericanLotus2024", gene_region: "chr1:500000-1500000" },
  { species: "AsianLotus", gene_region: "Chr01:1000000-2000000" },
  { species: "ZiLotus", gene_region: "LG01:1000000-2000000" },
 
];
export default generegionlist